/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetProjectUsageQueryResponse, ReportingControllerGetProjectUsageQueryParams, ReportingControllerGetProjectUsage400, ReportingControllerGetProjectUsage401, ReportingControllerGetProjectUsage403, ReportingControllerGetProjectUsage404 } from "../../models/reportingController/ReportingControllerGetProjectUsage";

function getReportingControllerGetProjectUsageUrl() {
  const res = { method: 'GET', url: `/api/v1/reporting/projects` as const }  
  return res
}

/**
 * @summary Get contract entitlement and project usage for an organization. projectsUsed is org-wide for the current contract year; projectsCreated honors the team and date filters.
 * {@link /api/v1/reporting/projects}
 */
export async function reportingControllerGetProjectUsage(params: ReportingControllerGetProjectUsageQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ReportingControllerGetProjectUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetProjectUsage400 | ReportingControllerGetProjectUsage401 | ReportingControllerGetProjectUsage403 | ReportingControllerGetProjectUsage404>, unknown>({ method : "GET", url : getReportingControllerGetProjectUsageUrl().url.toString(), params, ... requestConfig })  
  return res.data
}